let titleNodes: NodeListOf<Element> | null = null
let descriptionNodes: NodeListOf<Element> | null = null

export const MetadataSetters = {
  title: (s: string) => {
    if (!titleNodes) titleNodes = document.querySelectorAll("meta[property$=title], meta[name$=title]")
    document.title = s
    for (const node of titleNodes) {
      node.setAttribute("content", s)
    }
  },
  description: (s: string) => {
    if (!descriptionNodes) descriptionNodes = document.querySelectorAll("meta[property$=description], meta[name$=description]")
    for (const node of descriptionNodes) {
      node.setAttribute("content", s)
    }
  }
}